import React from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';

interface OverlayProps extends React.PropsWithChildren {
  showArrow?: boolean;
  className?: string;
}

export const Overlay: React.FC<OverlayProps> = ({
  children,
  showArrow = false,
  className,
}) => {
  return (
    <Container className={className} $showArrow={showArrow}>
      {children}
    </Container>
  );
};

const arrowStyles = css`
  position: absolute;
  top: -9px;
  left: calc(50% - 6px);
  width: 0;
  transform: translateY(50%);
  border-right: 6px solid transparent;
  border-bottom: 6px solid ${COLORS.White};
  border-left: 6px solid transparent;
`;

const Container = styled.div<{$showArrow: boolean}>`
  position: relative;
  padding: 1.25rem 1rem;
  border-radius: 2px;
  filter: drop-shadow(0 0px 16px rgba(0, 0, 0, 0.1));
  background: ${COLORS.White};

  ${({$showArrow}) =>
    $showArrow &&
    css`
      ::before {
        content: '';
        ${arrowStyles}
      }
    `}
`;

export const OverlayArrow = styled.div`
  ${arrowStyles}
`;
